/** Shared chrome so App Store and Google Play badges match (black pill, thin rim, light gloss). */

export function storeBadgeChromeSx(height) {
    const radius = Math.max(6, Math.round(height * 0.18));
    return {
        display: "inline-flex",
        alignItems: "center",
        gap: `${Math.max(7, height * 0.16)}px`,
        height,
        minHeight: height,
        boxSizing: "border-box",
        px: `${Math.max(10, height * 0.24)}px`,
        borderRadius: `${radius}px`,
        color: "#fff",
        textDecoration: "none",
        flexShrink: 0,
        border: "1.5px solid rgba(220, 220, 220, 0.95)",
        backgroundColor: "#000",
        backgroundImage:
            "linear-gradient(180deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.06) 40%, rgba(0,0,0,0) 55%)",
        boxShadow: "inset 0 1px 0 rgba(255,255,255,0.25)",
        transition: "opacity 0.2s ease",
        "&:hover": {
            opacity: 0.9,
            color: "#fff",
        },
    };
}

export function storeBadgeLine1Sx(height) {
    return {
        fontSize: Math.max(8, height * 0.2),
        fontWeight: 500,
        letterSpacing: "0.04em",
        lineHeight: 1.1,
        whiteSpace: "nowrap",
        display: "block",
    };
}

export function storeBadgeLine2Sx(height) {
    return {
        fontSize: Math.max(13, height * 0.36),
        fontWeight: 600,
        letterSpacing: "-0.02em",
        lineHeight: 1.1,
        whiteSpace: "nowrap",
        display: "block",
    };
}
